<div class="content-body">
  <button class="fab-new-order" (click)="createNewOrder()" matTooltip="Nueva orden" aria-label="Nueva orden">
    <mat-icon>add</mat-icon>
  </button>
  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
  <!-- row -->
  <div class="container-fluid orders-max-width">
    <div class="row">
      <div class="col-xl-12">
        <div class="card bg-transparent shadow-none">
          <div class="card-header flex-wrap border-0 p-0 justify-content-start">
            <div class="table-tabs me-2 mb-3 me-auto">
              <!-- <ul
                class="nav nav-tabs"
                ngbNav
                #nav1="ngbNav"
                [(activeId)]="active"
              >
                <li [ngbNavItem]="1" class="nav-item">
                  <a href="javascript:void(0);" ngbNavLink class="nav-link">
                    Todas
                  </a>
                  <ng-template ngbNavContent>
                    <table
                      matSort
                      class="table text-black dataTable card-table mb-4 table-responsive-lg dataTablesCard"
                      (matSortChange)="sortData($event)"
                    >
                      <thead>
                        <tr class="thead-primary">
                          <th mat-sort-header="id">Order ID</th>
                          <th mat-sort-header="date">Date</th>
                          <th mat-sort-header="table">Mesa</th>
                          <th mat-sort-header="amount">Total</th>
                          <th mat-sort-header="status">Estado</th>
                          <th style="background-image: none"></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for(row of allData.data; track row){
                        <tr>
                          <td>{{ row.id }}</td>
                          <td>{{ row.date }}</td>
                          <td>{{ row.table }}</td>
                          <td>{{ row.amount | currency }}</td>
                          <td>
                            @if(row.status == 'OPEN'){
                            <a
                              class="btn text-success bgl-success"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'PAYMENT_PENDING'){
                            <a
                              class="btn text-warning bgl-warning"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'CLOSED'){
                            <a
                              class="btn text-danger bgl-danger"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'CANCELLED'){
                            <a
                              class="btn text-danger bgl-danger"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'PAYMENT_FAILED'){
                            <a
                              class="btn text-danger bgl-danger"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            }
                          </td>
                          <td>
                            <div class="dropdown">
                              <a
                                class="btn-link"
                                href="javascript:void(0)"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 24 24"
                                  version="1.1"
                                >
                                  <g
                                    stroke="none"
                                    stroke-width="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                  >
                                    <rect
                                      x="0"
                                      y="0"
                                      width="24"
                                      height="24"
                                    ></rect>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="5"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="12"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="19"
                                      r="2"
                                    ></circle>
                                  </g>
                                </svg>
                              </a>
                              <div class="dropdown-menu dropdown-menu-end">
                                <a
                                  class="dropdown-item text-info"
                                  href="javascript:void(0);"
                                  >Accept Order</a
                                >
                                <a
                                  href="javascript:void(0);"
                                  data-dismiss="alert"
                                  aria-label="Close"
                                  class="dropdown-item text-danger"
                                  >Reject Order</a
                                >
                              </div>
                            </div>
                          </td>
                        </tr>
                        }
                      </tbody>
                    </table>
                    <div
                      class="dataTables_info float-start pt-2"
                      id="example5_info"
                      role="status"
                      aria-live="polite"
                    >
                      {{ page }} / {{ totalRows }} de
                      {{ allData.total }} ordenes
                    </div>
                    <div class="d-flex justify-content-center mt-2">
                      <app-pagination
                        [totalPage]="totalPage"
                        [page]="page"
                        [pageSize]="totalRows"
                        (newPage)="pageChange($event)"
                        (pageSizeChange)="onPageSizeChange($event)"
                      ></app-pagination>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="2" class="nav-item">
                  <a href="javascript:void(0);" ngbNavLink class="nav-link">
                    Open
                  </a>
                  <ng-template ngbNavContent>
                    <table
                      matSort
                      class="table text-black dataTable card-table mb-4 table-responsive-lg dataTablesCard"
                      (matSortChange)="sortData($event)"
                    >
                      <thead>
                        <tr class="thead-primary">
                          <th mat-sort-header="orderId">Order ID</th>
                          <th mat-sort-header="date">Date</th>
                          <th mat-sort-header="customerName">Customer Name</th>
                          <th mat-sort-header="location">Location</th>
                          <th mat-sort-header="amount">Amount</th>
                          <th mat-sort-header="status">Status Order</th>
                          <th style="background-image: none"></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for(row of allData.data; track row){
                        <tr>
                          @if(row.status == 'PENDING'){
                          <td>{{ row.orderId }}</td>
                          <td>{{ row.date }}</td>
                          <td>{{ row.customerName }}</td>
                          <td>{{ row.location }}</td>
                          <td>{{ row.amount | currency }}</td>
                          <td>
                            @if(row.status == 'DELIVERED'){
                            <a
                              class="btn text-success bgl-success"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'PENDING'){
                            <a
                              class="btn text-warning bgl-warning"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'CANCELED'){
                            <a
                              class="btn text-danger bgl-danger"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            }
                          </td>
                          <td>
                            <div class="dropdown">
                              <a
                                class="btn-link"
                                href="javascript:void(0)"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 24 24"
                                  version="1.1"
                                >
                                  <g
                                    stroke="none"
                                    stroke-width="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                  >
                                    <rect
                                      x="0"
                                      y="0"
                                      width="24"
                                      height="24"
                                    ></rect>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="5"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="12"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="19"
                                      r="2"
                                    ></circle>
                                  </g>
                                </svg>
                              </a>
                              <div class="dropdown-menu dropdown-menu-end">
                                <a
                                  class="dropdown-item text-info"
                                  href="javascript:void(0);"
                                  >Accept Order</a
                                >
                                <a
                                  href="javascript:void(0);"
                                  data-dismiss="alert"
                                  aria-label="Close"
                                  class="dropdown-item text-danger"
                                  >Reject Order</a
                                >
                              </div>
                            </div>
                          </td>
                          }
                        </tr>
                        }
                      </tbody>
                    </table>
                    <div
                      class="dataTables_info float-start pt-2"
                      id="example5_info"
                      role="status"
                      aria-live="polite"
                    >
                      Showing {{ page }} to {{ totalRows }} of
                      {{ allData.total }} entries
                    </div>
                    <div class="d-flex justify-content-center mt-2">
                      <app-pagination
                        [totalPage]="totalPage"
                        [page]="page"
                        [pageSize]="totalRows"
                        (newPage)="pageChange($event)"
                        (pageSizeChange)="onPageSizeChange($event)"
                      ></app-pagination>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="3" class="nav-item">
                  <a href="javascript:void(0);" ngbNavLink class="nav-link">
                    Closed
                  </a>
                  <ng-template ngbNavContent>
                    <table
                      matSort
                      class="table text-black dataTable card-table mb-4 table-responsive-lg dataTablesCard"
                      (matSortChange)="sortData($event)"
                    >
                      <thead>
                        <tr class="thead-primary">
                          <th mat-sort-header="orderId">Order ID</th>
                          <th mat-sort-header="date">Date</th>
                          <th mat-sort-header="customerName">Customer Name</th>
                          <th mat-sort-header="location">Location</th>
                          <th mat-sort-header="amount">Amount</th>
                          <th mat-sort-header="status">Status Order</th>
                          <th style="background-image: none"></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for(row of allData.data; track row){
                        <tr>
                          @if(row.status == 'PENDING'){
                          <td>{{ row.orderId }}</td>
                          <td>{{ row.date }}</td>
                          <td>{{ row.customerName }}</td>
                          <td>{{ row.location }}</td>
                          <td>{{ row.amount | currency }}</td>
                          <td>
                            @if(row.status == 'DELIVERED'){
                            <a
                              class="btn text-success bgl-success"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'PENDING'){
                            <a
                              class="btn text-warning bgl-warning"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'CANCELED'){
                            <a
                              class="btn text-danger bgl-danger"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            }
                          </td>
                          <td>
                            <div class="dropdown">
                              <a
                                class="btn-link"
                                href="javascript:void(0)"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 24 24"
                                  version="1.1"
                                >
                                  <g
                                    stroke="none"
                                    stroke-width="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                  >
                                    <rect
                                      x="0"
                                      y="0"
                                      width="24"
                                      height="24"
                                    ></rect>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="5"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="12"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="19"
                                      r="2"
                                    ></circle>
                                  </g>
                                </svg>
                              </a>
                              <div class="dropdown-menu dropdown-menu-end">
                                <a
                                  class="dropdown-item text-info"
                                  href="javascript:void(0);"
                                  >Accept Order</a
                                >
                                <a
                                  href="javascript:void(0);"
                                  data-dismiss="alert"
                                  aria-label="Close"
                                  class="dropdown-item text-danger"
                                  >Reject Order</a
                                >
                              </div>
                            </div>
                          </td>
                          }
                        </tr>
                        }
                      </tbody>
                    </table>
                    <div
                      class="dataTables_info float-start pt-2"
                      id="example5_info"
                      role="status"
                      aria-live="polite"
                    >
                      Showing {{ page }} to {{ totalRows }} of
                      {{ allData.total }} entries
                    </div>
                    <div class="d-flex justify-content-center mt-2">
                      <app-pagination
                        [totalPage]="totalPage"
                        [page]="page"
                        [pageSize]="totalRows"
                        (newPage)="pageChange($event)"
                        (pageSizeChange)="onPageSizeChange($event)"
                      ></app-pagination>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="4" class="nav-item">
                  <a href="javascript:void(0);" ngbNavLink class="nav-link">
                    Payment Pending
                  </a>
                  <ng-template ngbNavContent>
                    <table
                      matSort
                      class="table text-black dataTable card-table mb-4 table-responsive-lg dataTablesCard"
                      (matSortChange)="sortData($event)"
                    >
                      <thead>
                        <tr class="thead-primary">
                          <th mat-sort-header="orderId">Order ID</th>
                          <th mat-sort-header="date">Date</th>
                          <th mat-sort-header="customerName">Customer Name</th>
                          <th mat-sort-header="location">Location</th>
                          <th mat-sort-header="amount">Amount</th>
                          <th mat-sort-header="status">Status Order</th>
                          <th style="background-image: none"></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for(row of allData.data; track row){
                        <tr>
                          @if(row.status == 'DELIVERED'){
                          <td>{{ row.orderId }}</td>
                          <td>{{ row.date }}</td>
                          <td>{{ row.customerName }}</td>
                          <td>{{ row.location }}</td>
                          <td>{{ row.amount | currency }}</td>
                          <td>
                            @if(row.status == 'DELIVERED'){
                            <a
                              class="btn text-success bgl-success"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'PENDING'){
                            <a
                              class="btn text-warning bgl-warning"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            } @else if(row.status == 'CANCELED'){
                            <a
                              class="btn text-danger bgl-danger"
                              href="javascript:void(0);"
                              >{{ row.status }}</a
                            >
                            }
                          </td>
                          <td>
                            <div class="dropdown">
                              <a
                                class="btn-link"
                                href="javascript:void(0)"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 24 24"
                                  version="1.1"
                                >
                                  <g
                                    stroke="none"
                                    stroke-width="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                  >
                                    <rect
                                      x="0"
                                      y="0"
                                      width="24"
                                      height="24"
                                    ></rect>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="5"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="12"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="19"
                                      r="2"
                                    ></circle>
                                  </g>
                                </svg>
                              </a>
                              <div class="dropdown-menu dropdown-menu-end">
                                <a
                                  class="dropdown-item text-info"
                                  href="javascript:void(0);"
                                  >Accept Order</a
                                >
                                <a
                                  href="javascript:void(0);"
                                  data-dismiss="alert"
                                  aria-label="Close"
                                  class="dropdown-item text-danger"
                                  >Reject Order</a
                                >
                              </div>
                            </div>
                          </td>
                          }
                        </tr>
                        }
                      </tbody>
                    </table>
                    <div
                      class="dataTables_info float-start pt-2"
                      id="example5_info"
                      role="status"
                      aria-live="polite"
                    >
                      Showing {{ page }} to {{ totalRows }} of
                      {{ allData.total }} entries
                    </div>
                    <div class="d-flex justify-content-center mt-2">
                      <app-pagination
                        [totalPage]="totalPage"
                        [page]="page"
                        [pageSize]="totalRows"
                        (newPage)="pageChange($event)"
                        (pageSizeChange)="onPageSizeChange($event)"
                      ></app-pagination>
                    </div>
                  </ng-template>
                </li>
              </ul> -->
              <div class="top-range-controls">
                <button class="range-btn" [class.active]="selectedRange === 'today'" (click)="onRangeChange('today')">Hoy</button>
                <button class="range-btn" [class.active]="selectedRange === 'week'" (click)="onRangeChange('week')">Semana</button>
                <button class="range-btn" [class.active]="selectedRange === 'month'" (click)="onRangeChange('month')">Mes</button>
              </div>
              <!-- Controles específicos para Mes: actual / anterior -->
              <div class="top-range-controls" *ngIf="selectedRange === 'month'">
                <button class="range-btn" [class.active]="monthOffset === 0" (click)="setMonthOffset(0)">Mes en curso</button>
                <button class="range-btn" [class.active]="monthOffset === -1" (click)="setMonthOffset(-1)">Mes anterior</button>
              </div>
              <!-- Filtros por tipo: barra flotante con íconos (igual a "Mesas") -->
              <div class="floating-type-tabs">
                <button class="type-btn" [ngClass]="{active: activeType==='LOCAL'}" (click)="setActiveType('LOCAL')" aria-label="Local">
                  <span class="material-icons">restaurant</span>
                </button>
                <button class="type-btn" [ngClass]="{active: activeType==='DELIVERY'}" (click)="setActiveType('DELIVERY')" aria-label="Delivery">
                  <span class="material-icons">delivery_dining</span>
                </button>
                <button class="type-btn" [ngClass]="{active: activeType==='PICKUP'}" (click)="setActiveType('PICKUP')" aria-label="Pickup">
                  <span class="material-icons">storefront</span>
                </button>
                <button class="type-btn" [ngClass]="{active: activeType==='FOODTRUCK'}" (click)="setActiveType('FOODTRUCK')" aria-label="Foodtruck">
                  <span class="material-icons">fastfood</span>
                </button>
              </div>
              <ul
                class="nav nav-tabs one-row floating-top"
                ngbNav
                #nav1="ngbNav"
                [(activeId)]="active"
              >
                <li [ngbNavItem]="1" class="nav-item">
                  <a href="javascript:void(0);" ngbNavLink class="nav-link"
                    >Todas</a
                  >
                  <ng-template ngbNavContent>
                    <ng-container
                      *ngTemplateOutlet="
                        tableTemplate;
                        context: {
                          data: allData.data,
                          page: page,
                          totalRows: totalRows,
                          total: allData.total,
                          totalPage: totalPage
                        }
                      "
                    ></ng-container>
                  </ng-template>
                </li>
                <li [ngbNavItem]="2" class="nav-item">
                  <a href="javascript:void(0);" ngbNavLink class="nav-link"
                    >Abiertas</a
                  >
                  <ng-template ngbNavContent>
                    <ng-container
                      *ngTemplateOutlet="
                        tableTemplate;
                        context: {
                          data: openData.data,
                          page: page,
                          totalRows: totalRows,
                          total: openData.total,
                          totalPage: totalPage
                        }
                      "
                    ></ng-container>
                  </ng-template>
                </li>
                <li [ngbNavItem]="3" class="nav-item">
                  <a href="javascript:void(0);" ngbNavLink class="nav-link"
                    >Cerradas</a
                  >
                  <ng-template ngbNavContent>
                    <ng-container
                      *ngTemplateOutlet="
                        tableTemplate;
                        context: {
                          data: closedData.data,
                          page: page,
                          totalRows: totalRows,
                          total: closedData.total,
                          totalPage: totalPage
                        }
                      "
                    ></ng-container>
                  </ng-template>
                </li>
                <li [ngbNavItem]="4" class="nav-item">
                  <a href="javascript:void(0);" ngbNavLink class="nav-link"
                    >Por pagar</a
                  >
                  <ng-template ngbNavContent>
                    <ng-container
                      *ngTemplateOutlet="
                        tableTemplate;
                        context: {
                          data: pendingPaymentData.data,
                          page: page,
                          totalRows: totalRows,
                          total: pendingPaymentData.total,
                          totalPage: totalPage
                        }
                      "
                    ></ng-container>
                  </ng-template>
                </li>
              </ul>

              <ng-template
                #tableTemplate
                let-data="data"
                let-page="page"
                let-totalRows="totalRows"
                let-total="total"
                let-totalPage="totalPage"
              >
                <div class="orders-grid">
                  <app-order-card
                    *ngFor="let row of data"
                    [orderId]="row.order.id"
                    [date]="row.date"
                    [tableName]="row.table.name"
                    [tableType]="row.table.type"
                    [status]="row.status"
                    [total]="row.amount"
                    [itemSummary]="row.itemSummary"
                    [itemCounts]="row.itemCounts"
                    [items]="row.itemsList"
                    [productSummary]="row.productSummary"
                    [paymentSummary]="row.paymentSummary"
                    [priceSummary]="row.priceSummary"
                    [customerName]="row.customerName"
                    [isAdmin]="isAdmin"
                    (clicked)="navigateToOrderEdit(row)"
                    (editClicked)="navigateToOrderEdit(row)"
                    (deleted)="forceDelete(row)"
                  ></app-order-card>
                </div>
                <div class="d-flex justify-content-center mt-3">
                  <app-pagination
                    [totalPage]="totalPage"
                    [page]="page"
                    [pageSize]="totalRows"
                    (newPage)="pageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)"
                  ></app-pagination>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="card-body p-0">
            <div class="tab-content" id="Tab">
              <div class="tab-pane fade active show">
                <div class="table-responsive rounded table-hover pb-2">
                  <div [ngbNavOutlet]="nav1"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
